import { render, staticRenderFns } from "./RenderContent.vue?vue&type=template&id=500df2d8&"
import script from "./RenderContent.vue?vue&type=script&lang=js&"
export * from "./RenderContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports